import { Benefits } from '@sunwebgroup/uds-ui/benefits'
import { Layout } from '@sunwebgroup/uds-ui/layout'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import * as React from 'react'
import { CatalogueType } from '@/config/types'
import { useIntl } from '@/intl'
import { useBreakpoints } from '@/scopes/common/components/utils/breakpoints'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import styles from './ContentUsps.module.css'

function getPrefix(catalogueType?: CatalogueType): string {
  if (catalogueType === 'summer') {
    return 'content_home_summer'
  }

  if (catalogueType === 'winter') {
    return 'content_home_winter'
  }

  return 'content_splash'
}

export default function ContentUsps() {
  const intl = useIntl()
  const { isTablet } = useBreakpoints()
  const links = useConfiguration('links')
  const catalogueType = useConfiguration('catalogueType')
  const prefix = getPrefix(catalogueType)
  return (
    <Layout className={styles.wrapper}>
      <div>
        <Typography variant="display-e-regular">{intl.formatMessage({ id: `${prefix}_usp_title` })}</Typography>
      </div>
      <div>
        <Benefits.Root display={isTablet ? 'gridTwoColumns' : 'list'}>
          {links.usp1 && (
            <Benefits.Item
              title={intl.formatMessage({ id: `${prefix}_usp_1_title` })}
              supportingText={
                intl.formatMessage(
                  { id: `${prefix}_usp_1_supporting_text` },
                  { a1: (chunks: string[]) => `<a href="${links.usp1}">${chunks.join('')}</a>` },
                ) as string
              }
            />
          )}
          {links.usp2 && (
            <Benefits.Item
              title={intl.formatMessage({ id: `${prefix}_usp_2_title` })}
              supportingText={
                intl.formatMessage(
                  { id: `${prefix}_usp_2_supporting_text` },
                  { a1: (chunks: string[]) => `<a href="${links.usp2}">${chunks.join('')}</a>` },
                ) as string
              }
            />
          )}
          {links.usp3 && (
            <Benefits.Item
              title={intl.formatMessage({ id: `${prefix}_usp_3_title` })}
              supportingText={
                intl.formatMessage(
                  { id: `${prefix}_usp_3_supporting_text` },
                  { a1: (chunks: string[]) => `<a href="${links.usp3}">${chunks.join('')}</a>` },
                ) as string
              }
            />
          )}
          {links.usp4 && (
            <Benefits.Item
              title={intl.formatMessage({ id: `${prefix}_usp_4_title` })}
              supportingText={
                intl.formatMessage(
                  { id: `${prefix}_usp_4_supporting_text` },
                  { a1: (chunks: string[]) => `<a href="${links.usp4}">${chunks.join('')}</a>` },
                ) as string
              }
            />
          )}
        </Benefits.Root>
      </div>
    </Layout>
  )
}
